import Styles from './SocialFloat.module.scss'
import { ReactComponent as TwitterIcon } from 'assets/icons/socialTwitter16.svg'
import { ReactComponent as FacebookIcon } from 'assets/icons/socialFb16.svg'
import { ReactComponent as LinkedinIcon } from 'assets/icons/socialLinkedin16.svg'
import { ReactComponent as EmailIcon } from 'assets/icons/socialEmail16.svg'
import { ReactComponent as LinkIcon } from 'assets/icons/socialLink16.svg'
import { Profile, SocialNetwork } from 'types'
import { copyToClipboard } from 'utils'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import client from 'api/client'
import { TWITTER_HANDLE } from 'utils/constants'
import { getLocationUrl } from 'hooks/useHistory'

interface Props {
  articleId: string
  title: string
  articleLink: string
  horizontal?: boolean
  showLink?: boolean
  twitter?: Profile['twitter']
  showRailToggle?: boolean
}

const SocialFloat = ({ articleId, title, articleLink, twitter, horizontal = false, showLink = true }: Props) => {
  const address = `${getLocationUrl().hostname}${articleLink}`
  const formattedTitle = title.replace(/@/g, '@ ')
  const twitterText = !!twitter ? `${formattedTitle} by @${twitter}` : formattedTitle

  const logShare = (network: SocialNetwork) => {
    client.postSocialShare(articleId, network)
  }

  return (
    <div className={horizontal ? Styles.horizontal : ''}>
      {showLink && (
        <button
          className={Styles.socialButton}
          onClick={() => {
            copyToClipboard(address)
            showToastMessage('Article link copied to clipboard! 🎉', 'success')
            logShare('link')
          }}
        >
          <LinkIcon />
        </button>
      )}
      <a
        target="_blank"
        rel="noopener noreferrer ugc"
        href={`https://twitter.com/share?url=https://${address}&text=${twitterText} ${TWITTER_HANDLE}`}
        onClick={() => logShare('twitter')}
      >
        <button className={Styles.socialButton}>
          <TwitterIcon />
        </button>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer ugc"
        href={`https://www.facebook.com/sharer/sharer.php?u=https://${address}`}
        onClick={() => logShare('facebook')}
      >
        <button className={Styles.socialButton}>
          <FacebookIcon />
        </button>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer ugc"
        href={`https://www.linkedin.com/shareArticle?&url=https://${address}&title=${formattedTitle}`}
        onClick={() => logShare('linkedin')}
      >
        <button className={Styles.socialButton}>
          <LinkedinIcon />
        </button>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer ugc"
        href={`mailto:?&subject=${formattedTitle}&body=https://${address}`}
        onClick={() => logShare('email')}
      >
        <button className={Styles.socialButton}>
          <EmailIcon />
        </button>
      </a>
    </div>
  )
}

export default SocialFloat
